import { render, staticRenderFns } from "./ProfilForm.vue?vue&type=template&id=da7b10d4&scoped=true"
import script from "./ProfilForm.vue?vue&type=script&lang=js"
export * from "./ProfilForm.vue?vue&type=script&lang=js"
import style0 from "./ProfilForm.vue?vue&type=style&index=0&id=da7b10d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7b10d4",
  null
  
)

export default component.exports